(function() {
    angular
        .module("app")
        .controller("BroadcastSpeedWarningModalController", BroadcastSpeedWarningModalController)

    BroadcastSpeedWarningModalController.$inject = [
        "$state",
        "$scope",
        "$uibModal",
        "$uibModalInstance",
        "options"
    ]

    function BroadcastSpeedWarningModalController(
        $state,
        $scope,
        $uibModal,
        $uibModalInstance,
        options
    ){
        "use strict"

        $scope.ok = function() {
            $uibModalInstance.close()
            $uibModal.open({
                templateUrl: "app/modals/set-speed-display.view.html",
                controller: "SetSpeedDisplayModalController",
                resolve: {
                    options: function() {
                        return options
                    }
                }
            }).result.catch(function(res) {
                if (!(res === "cancel" || res === "escape key press")) {
                    throw res
                }
            })
        }

        $scope.cancel = function() {
            $uibModalInstance.dismiss("cancel")
        }
    }
})()
